// extracted by mini-css-extract-plugin
export var active = "menu-module--active--wjkws";
export var button = "menu-module--button--omQft";
export var mobilemenu = "menu-module--mobilemenu--wb2mS";
export var navmenu = "menu-module--navmenu--czgxD";